import { render, staticRenderFns } from "./HospitalEdit.vue?vue&type=template&id=05673452"
import script from "./HospitalEdit.vue?vue&type=script&lang=ts"
export * from "./HospitalEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports